import { Avatar, Box, Text } from "@chakra-ui/react";

const UserListItem = ({ user, handleFunction }) => {
  return (
    <Box
      onClick={handleFunction}
      cursor="pointer"
      bg="#E8E8E8"
      _hover={{
        background: "#38B2AC",
        color: "white",
      }}
      width="100%" // Changed `w` to `width` for better readability
      display="flex" // Fixed `d` to `display`
      alignItems="center"
      color="black"
      px={3}
      py={2}
      mb={2}
      borderRadius="lg"
    >
      <Avatar
        mr={2}
        size="sm"
        cursor="pointer"
        name={user?.name} // Added optional chaining to prevent errors if `user` is undefined
        src={user?.pic}
      />
      <Box>
        <Text fontWeight="bold">{user?.name}</Text>{" "}
        {/* Added `fontWeight` for better visual hierarchy */}
        <Text fontSize="xs">
          <b>Email: </b>
          {user?.email}
        </Text>
      </Box>
    </Box>
  );
};

export default UserListItem;
